// File excluded from token migration due to dynamic nature
// https://atlassian.slack.com/archives/CFJ9DU39U/p1709665443238399
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import { layers } from '@atlaskit/theme/constants';

type BannerType = {
	isContentCreationPanelOpen: boolean;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const BannerContainer = styled.div<BannerType>({
	height: '52px',
	background: token('color.background.accent.purple.subtler'),
	position: 'absolute',
	left: 0,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	right: `${({ isContentCreationPanelOpen }) => (isContentCreationPanelOpen ? '320px' : 0)}`,
	zIndex: layers.card(),
	transition: 'right 0.1s linear, top 0.5s linear, margin-top 0.5s linear',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Banner = styled.div({
	position: 'relative',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	height: '100%',
	width: '100%',
	textAlign: 'center',
	padding: `0 ${token('space.600')}`,
	boxSizing: 'border-box',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const IconContainer = styled.div({
	position: 'absolute',
	right: token('space.250'),
	top: token('space.200'),
	cursor: 'pointer',
	zIndex: layers.card(),
});
